import styled from 'styled-components';
import { withStyles } from '@material-ui/core/styles';
import { FormHelperText as MuiFormHelperText } from '@material-ui/core';
import { dangerColor, dangerTextColor, successColor } from '../../../lib/theme';

export interface IFormOption {
  label: string;
  value: string;
}

interface IFormInput {
  light?: boolean;
  fullWidth?: boolean;
  width?: string;
  ref?: any;
  // Transient (styled-components `$`) so it styles the control without reaching the DOM.
  $hasError?: boolean;
}

export const FormInput = styled.input<IFormInput>`
  background: ${props => props.light ? '#fff' : '#fafcfe'};
  border: 1px solid ${props => props.$hasError ? dangerColor : '#ddd'};
  border-radius: 4px;
  padding: 8px;
  width: ${props => props.fullWidth ? '100%' : (props.width || 'auto')};

  &:focus {
    outline-color: ${props => props.$hasError ? dangerColor : '#bdd739'};
  }
`;

export const FormLabel = styled.label<IFormInput>`
  margin-bottom: 8px;
  font-weight: 500;
  color: ${props => props.$hasError ? dangerTextColor : 'inherit'};
`;

export const FormHelperText = withStyles({
  root: {
    fontFamily: 'Quicksand, sans-serif;',
    fontWeight: 700,
    // Compound selector so this out-specifies MUI's own .Mui-error rule, which
    // otherwise wins and paints its default red (#f44336, only 3.8:1 on white).
    '&.Mui-error': {
      color: dangerTextColor,
    },
    '& .success': {
      color: `${successColor} !important`
    }
  },
})(MuiFormHelperText);

export const FormTextArea = styled.textarea<IFormInput>`
  border-radius: 4px;
  border: 1px solid ${props => props.$hasError ? dangerColor : '#ddd'};
  background: ${props => props.light ? '#fff' : '#fafcfe'};
  padding: 8px;
  width: ${props => props.fullWidth ? '100%' : (props.width || 'auto')};

  &:disabled {
    background: #e0e4e8;
  }
`;
